import { OccupationDominanteRiveGauche } from '../SANDRE/occ-dominanteRG';
import { OccupationDominanteRiveDroite } from '../SANDRE/occDominanteRD';
import { NatureBergeGauche } from '../SANDRE/nature-berge-gauche';
import { NatureBergeDroite } from '../SANDRE/nature-berge-droite';
import { AspectAbord } from '../SANDRE/aspect-abord';
import { ETypeVegetation } from '../SANDRE/type-vegetation-name';
import { EImportanceVegetationBerge } from '../SANDRE/importance-vegetation-berge';

export class NatureBerge {
    id: number; // For IndexedDB
    interventionId: number;
    
    OccupationDominanteRG: OccupationDominanteRiveGauche;
    OccupationDominanteRD: OccupationDominanteRiveDroite;
    NatureBergeGauche: NatureBergeGauche;
    NatureBergeDroite: NatureBergeDroite;
    ImportanceVegetationBerge: EImportanceVegetationBerge;
    TypeVegetation: ETypeVegetation;
    AspectAbord: AspectAbord;

    static mapFromJSON(json: any): NatureBerge {
        const n = new NatureBerge();

        n.OccupationDominanteRG = json.occDominanteRG;
        n.OccupationDominanteRD = json.occDominanteRD;
        n.NatureBergeGauche = json.natureBergeGauche;
        n.NatureBergeDroite = json.natureBergeDroite;
        n.AspectAbord = json.aspectAbord;
        n.TypeVegetation = json.typeVegetation;
        n.ImportanceVegetationBerge = json.importanceVegetationBerge;

        return n;
    }
}
